import { render, staticRenderFns } from "./wechatIndex.vue?vue&type=template&id=518aef0c&scoped=true"
import script from "./wechatIndex.vue?vue&type=script&lang=js"
export * from "./wechatIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518aef0c",
  null
  
)

export default component.exports